import { render, staticRenderFns } from "./ReviewsStatComponent.vue?vue&type=template&id=02ebf352"
import script from "./ReviewsStatComponent.vue?vue&type=script&lang=js"
export * from "./ReviewsStatComponent.vue?vue&type=script&lang=js"
import style0 from "./ReviewsStatComponent.vue?vue&type=style&index=0&id=02ebf352&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports